/*
 * @Describe:
 * @Author: wangalong
 * @LastEditTime: 2022-11-03 14:44:08
 */
import router from '../router'
import { jumpForAction } from './kb-bridge'
import Vue from 'vue'
import { isKbApp, notonKbApp, onKbApp } from '@/hooks/use-env'

//移动终端浏览器版本信息
export function getWebAgent() {
    var u = navigator.userAgent
    return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果内核
        chrome: u.indexOf('chrome') > -1, //谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        wx: u.indexOf('MicroMessenger') > 0, //是否是微信
    }
}

/**
 * 重定向
 * @param {object} param
 * @param {string} param.url
 */
export function redirectTo({ url }) {
    const aElement = document.createElement('a')
    aElement.href = url

    if (aElement.host === window.location.host) {
        return router.replace(aElement.pathname + aElement.search + aElement.hash)
    }

    return window.location.replace(url)
}

/**
 * 前往
 * @param {object} param
 * @param {string} param.url
 */
export function navigateTo({ url }) {
    if (url.indexOf('http') !== 0) {
        return router.push(url)
    }

    const aElement = document.createElement('a')
    aElement.href = url

    if (aElement.host === window.location.host) {
        return router.push(aElement.pathname + aElement.search + aElement.hash)
    }

    return window.location.assign(url)
}

/**
 * 打开新窗口,体验上不会销毁当前页面,在微信上,也能正常的后退
 * @param {object} param
 * @param {string} param.url
 */
export function navigateOpen({ url }) {
    // 经测试, ios app中无法使用window.open
    if (isKbApp) {
        return navigateTo({ url })
    }
    window.open(url)
}

/** 重定向到QQ应用宝 */
export function navigateToQQAppStore() {
    navigateTo({ url: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hz.czfw.app' })
}

/** 跳转到918商城 */
export function navigateTo918Mall({ url }) {
    notonKbApp(() => {
        navigateTo({ url })
    })
    onKbApp(() => {
        jumpForAction(Vue.prototype, 'pageYouzanWeb', {
            url,
        })
    })
}

/**
 * 当value指定了单位的时候,不进行任何转换,当未指定的时候,转成vw单位
 * @param {number|string} value
 * @returns
 */
export function px2vw(value) {
    if (!value) {
        return value
    }
    if (isNaN(Number(value))) {
        return value
    }

    return (Number(value) / 375) * 100 + 'vw'
}

/**
 *
 * @description 获取自增id
 */
export function getAutoIncrementId() {
    if (!window['window/auto-increment-id']) {
        window['window/auto-increment-id'] = 1
    }

    return window['window/auto-increment-id']++
}
